import { DidacticResource } from 'types';

import { api } from './api';

export async function getDidacticResourcesByCourse(courseId?: string): Promise<DidacticResource[]> {
  if (!courseId) return [];

  const { data } = await api.post('database/recurso_didatico__c/aggregate', [
    {
      $match: {
        ref: courseId,
      },
    },
    {
      $sort: {
        updated: -1,
        created: -1,
      },
    },
  ]);

  if (!Array.isArray(data)) {
    return [];
  }

  return data;
}
